import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const AppointmentInstructions = ({ className, value }) => {
  const { t } = useTranslation('OrdersOrderDetail');

  return (
    <div className={className} data-testid="appointment-instructions">
      <p className="label">{t(`appointment_instructions_section_title`)}:</p>
      <div className="instructions" data-testid="instructions">
        &quot;{value}&quot;
      </div>
    </div>
  );
};

AppointmentInstructions.propTypes = {
  value: PropTypes.string,
};

AppointmentInstructions.defaultProps = {
  value: '',
};

export default AppointmentInstructions;
